module.exports = __webpack_public_path__ + "static/img/icon_szh_sdnl_rjkf.d0944fe4.png";